declare global {
  interface Window {
    newrelic?: {
      noticeError?: (
        error: Error | string,
        customAttributes?: Record<string, string | number>,
      ) => void;
      addRelease?: (name: string, id: string) => void;
    };
  }
}

declare var window: Window;

class NewRelicHelper {
  static setRelease(name: string, id: string) {
    window.newrelic?.addRelease?.(name, id);

    if (process.env.NODE_ENV === "development") {
      console.info("Setting version to", name, id);
    }
  }
  /**
   * Log errors to New Relic, if available.
   * See: https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/noticeerror/
   *
   * @param error - The error object or string message to be logged.
   * @param customAttributes - Optional custom attributes to include with the error.
   */
  static logError(error: unknown, customAttributes?: Record<string, string | number>) {
    if (error instanceof Error || typeof error === "string") {
      window.newrelic?.noticeError?.(error, customAttributes);

      if (process.env.NODE_ENV === "development") {
        console.error("An error occurred", error);
      }
    }
  }
}

export default NewRelicHelper;
